import typeIs, { isObject, isArray } from './type.mjs';

/**
 * 判断对象是否为纯对象
 * @param {object} obj
 * @returns {boolean}
 */
const isPlainObject = (obj) => {
    if (!isObject(obj))
        return false;
    const proto = Object.getPrototypeOf(obj);
    // 对象无原型
    if (!proto)
        return true;
    // 是否对象直接实例
    return proto === Object.prototype;
};
/**
 * 判断对象内是否有该静态属性
 * @param {object} obj
 * @param {string} key
 * @returns {boolean}
 */
const objectHas = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);
/**
 * 遍历对象，返回 false 中断遍历
 * @param {Record<K, V>} obj
 * @param {(val: V, key: K) => boolean} iterator
 */
const objectEach = (obj, iterator) => {
    for (const key in obj) {
        if (!objectHas(obj, key))
            continue;
        if (iterator(obj[key], key) === false)
            break;
    }
};
const merge = (map, source, target) => {
    const sourceType = typeIs(source);
    const targetType = typeIs(target);
    if (sourceType !== targetType) {
        if (isArray(target))
            return merge(map, [], target);
        if (isObject(target))
            return merge(map, {}, target);
        return target;
    }
    // 朴素对象
    if (isPlainObject(target)) {
        const exist = map.get(target);
        if (exist)
            return exist;
        map.set(target, source);
        objectEach(target, (val, key) => {
            source[key] = merge(map, source[key], val);
        });
        return source;
    }
    // 任意对象
    else if (isObject(target)) {
        const exist = map.get(target);
        if (exist)
            return exist;
        map.set(target, source);
        const keys = Object.keys(target);
        keys.forEach((key) => {
            source[key] = merge(map, source[key], target[key]);
        });
        return source;
    }
    // 数组
    else if (isArray(target)) {
        const exist = map.get(target);
        if (exist)
            return exist;
        map.set(target, source);
        target.forEach((val, index) => {
            source[index] = merge(map, source[index], val);
        });
        return source;
    }
    return target;
};
const objectAssign = (source, ...args) => {
    let target;
    const map = new Map();
    while ((target = args.shift())) {
        merge(map, source, target);
    }
    map.clear();
    return source;
};

export { isPlainObject, objectAssign, objectEach, objectHas };
